module.exports = __webpack_public_path__ + "static/media/CalciteWebCoreIcons.2458082a.woff";